import { SIGNUP_SOURCE_RE } from '@feral/shared/client'

/**
 * Where a visitor came from (GR-60): the `?src=` tag on the link they opened (a card, a post, an
 * ambassador's link), kept on this device until they sign up. The first tag in 30 days wins, so a
 * later link doesn't take the credit; the tag leaves the address bar so a shared link doesn't carry it.
 */
const KEY = 'fml.src'
const KEEP_MS = 30 * 86400_000
/** The tag on this visit's own link, whichever one is kept: `/` carries it on (decision 135). */
let arrived: string | undefined
export const arrivalSource = () => arrived

export function captureSource() {
  try {
    const url = new URL(window.location.href)
    const raw = url.searchParams.get('src')
    if (raw === null) return
    url.searchParams.delete('src')
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash)
    const src = raw.trim().toLowerCase()
    if (!SIGNUP_SOURCE_RE.test(src)) return
    arrived = src
    if (signupSource()) return
    localStorage.setItem(KEY, JSON.stringify({ src, at: Date.now() }))
  } catch {}
}

/** The tag to send with sign-up, or undefined. */
export function signupSource(): string | undefined {
  try {
    const kept = JSON.parse(localStorage.getItem(KEY) ?? 'null') as { src: string; at: number } | null
    if (kept && Date.now() - kept.at < KEEP_MS) return kept.src
  } catch {}
  return undefined
}

/** After sign-up: the tag has been counted. */
export function clearSource() {
  try {
    localStorage.removeItem(KEY)
  } catch {}
}
